import React, { Component, Fragment } from "react";
import { browserHistory } from "react-router";
import { connect } from "react-redux";
import alasql from "alasql";
import BacktestService from "../../service/backtest.service";
import PortfolioCards from "../myPortfolios/PortfolioCards";
import MyPortfolioTable from "./MyPortfolio/myPortfolioTable";
import SearchField from "../common/searchField";
import "./myportfolio.scss";

class Portfolios extends Component {
  _isMounted = false;
  state = {
    live: [],
    benchmark: [],
    compare: [],
    data: [],
    resLive: [],
    resBacktest: [],
    newData: [],
    selected: [],
    displayNoProf: false,
    searchFieldInput: "",
    display: "grid_view",
    dataFetching: false,
    failedToLoadCOMPARE: false,
    failedToLoadLIVE: false,
    failedToLoadBACKTEST: false,
    simulations: true,
    create_button: true,
  };
  async componentDidMount() {
    this._isMounted = true;
    //resetting compare portfolio data
    this.props.resetComparePortfolioData();
    this.props.resetCreatePortfolioAnalyze();
    this.props.resetDirectReviewPortfolio();
    this.props.resetUniverseData();
    this.props.resetCurrentActiveStep(0);
    this.props.resetSecuritiesValidToNextStep(true);
    //****************/
    // -------------------
    this.setState({
      dataFetching: true,
    });
    await BacktestService.getScenarioClient().then((res) => {
      try {
        this.setState({
          dataFetching: true,
        });

        if (res && this._isMounted) {
          let compare = this.filterData({ data: res });
          this.setState({
            compare,
            dataFetching: false,
            failedToLoadCOMPARE: false,
          });
        }
      } catch (error) {
        this.setState({
          dataFetching: false,
          failedToLoadCOMPARE: true,
        });
      }
    });
    await BacktestService.getScenariosNew("LIVE").then((res) => {
      try {
        this.setState({
          dataFetching: true,
        });

        if (res && this._isMounted) {
          let live = this.filterData({ data: res });
          this.setState({
            live: live,
            dataFetching: false,
            failedToLoadLIVE: false,
          });
        }
      } catch (error) {
        this.setState({
          dataFetching: false,
          failedToLoadLIVE: true,
        });
      }
    });
    await BacktestService.getScenariosNew("BACKTEST").then((res) => {
      try {
        this.setState({
          dataFetching: true,
        });

        if (res && this._isMounted) {
          let benchmark = this.filterData({ data: res });

          this.groupData({ live: this.state.live, benchmark });

          this.setState({
            benchmark: benchmark,
            dataFetching: false,
            failedToLoadBACKTEST: false,
          });
        }
      } catch (error) {
        console.log(error, "catch error");
        this.setState({
          failedToLoadBACKTEST: true,
          dataFetching: false,
        });
      }
    });
  }
  componentWillMount() {
    this.props.setPath(["My Portfolios"]);
    let _user_preferences = window.localStorage._user_preferences
      ? JSON.parse(window.localStorage._user_preferences)
      : false;

    if (_user_preferences) {
      let simulations = _user_preferences["simulations"];
      let create_button = _user_preferences["create_portfolio"];
      if (process.env.NODE_ENV !== "production") create_button = true;

      this.setState({
        simulations: simulations,
        create_button: create_button,
      });
    }
  }
  componentWillReceiveProps(nextProps) {
    let _user_preferences = window.localStorage._user_preferences
      ? JSON.parse(window.localStorage._user_preferences)
      : false;

    if (_user_preferences) {
      let simulations = _user_preferences["simulations"];
      let create_button = _user_preferences["create_portfolio"];
      if (process.env.NODE_ENV !== "production") create_button = true;

      this.setState({
        simulations: simulations,
        create_button: create_button,
      });
    }
  }
  filterData = ({ data }) => {
    let x = [];
    for (let i in data) {
      var obj = { ...data[i] };

      let {
        // scenario_name,
        // scenario_id,
        // type,
        // bm_annualized_return,
        // fund_annualized_return,
        // alpha,
        // beta,
        // sortino_ratio,
        // benchmark_name,
        // benchmark,
        // client_portfolio_id,
        scn_status,
      } = data[i];

      // obj["scenario_id"] = scenario_id;
      // obj["type"] = type;
      // obj["bm_annualized_return"] = bm_annualized_return;
      // obj["fund_annualized_return"] = fund_annualized_return;
      // obj["scenario_name"] = scenario_name;
      // obj["alpha"] = alpha;
      // obj["beta"] = beta;
      // obj["sortino_ratio"] = sortino_ratio;
      // obj["benchmark_name"] = benchmark_name;
      // obj["benchmark"] = benchmark;
      // obj["client_portfolio_id"] = client_portfolio_id;
      obj["scn_status"] = scn_status.toUpperCase();
      x.push(obj);
    }
    return x;
  };
  groupData = ({ live, benchmark }) => {
    let data = live.concat(benchmark);
    let newObj = { LIVE: [], BACKTEST: [], DEFAULT: [] };

    for (let j in data) {
      newObj["DEFAULT"].push(data[j]);
      if (data[j]["type"] === "LIVE") {
        newObj["LIVE"].push(data[j]);
      } else {
        newObj["BACKTEST"].push(data[j]);
      }
    }
    this.setState({
      data,
      newData: newObj,
      selected: newObj["DEFAULT"],
    });
    if (data.length === 0) {
      this.setState({
        displayNoProf: true,
      });
    }
  };

  handleChange = (e) => {
    this.setState({
      selected: this.state.newData[e.target.value],
    });
  };
  navigateTOCreate = () => {
    browserHistory.push("/create");
  };

  contactAdmin = () => {
    alert("Please Contact Your Admin.");
  };

  // active tabe handler
  classNameHandler = (e) => {
    let name = e.target.getAttribute("name");
    this.setState({
      display: name,
    });
  };
  // ****Table View *******
  // search handler
  searchHandler = (e) => {
    let value = e.target.value.toUpperCase();
    this.setState({
      searchFieldInput: value,
    });
  };

  clearSearchFieldHandler = () => {
    this.setState({
      searchFieldInput: "",
    });
  };
  filterByName = (item) => {
    if (item.scenario_name) {
      return true;
    }
    return false;
  };

  componentWillUnmount() {
    this._isMounted = false;
  }
  render() {
    const {
      selected,
      displayNoProf,
      display,
      dataFetching,
      compare,
      simulations,
      create_button,
    } = this.state;
    var sortedData = alasql("SELECT * FROM ? ORDER BY scenario_id", [selected]);
    var { searchFieldInput } = this.state;

    // sortedData.filter(this.filterByName);
    let filtered = sortedData.filter(this.filterByName);

    // filter searched data
    const NewsortedData = filtered.filter((d) => {
      if (searchFieldInput == null) {
        return filtered;
      } else {
        return (
          d.scn_status.toUpperCase().indexOf(searchFieldInput) !== -1 ||
          d.scenario_name.toUpperCase().indexOf(searchFieldInput) !== -1 ||
          d.benchmark.toUpperCase().indexOf(searchFieldInput) !== -1 ||
          d.scenario_id.toString().indexOf(searchFieldInput) !== -1
        );
      }
    });

    return (
      <div className="page-content">
        <div className="head-section">
          <div className="head-section__togglebtns">
            <button
              className={
                "custom_btn " +
                (this.state.display === "grid_view" ? "active_btn" : "")
              }
              name="grid_view"
              onClick={(e) => {
                this.classNameHandler(e);
              }}
            >
              <i
                className="fa fa-th-large head-section__togglebtns__icons"
                aria-hidden="true"
                name="grid_view"
              ></i>
            </button>{" "}
            <button
              className={
                "custom_btn " +
                (this.state.display === "table_view" ? "active_btn" : "")
              }
              name="table_view"
              onClick={(e) => {
                this.classNameHandler(e);
              }}
            >
              <i
                className="fa fa-bars head-section__togglebtns__icons"
                aria-hidden="true"
                name="table_view"
              ></i>
            </button>
          </div>
          <div>
            {/*<button
              className="custom_btn btn_pos"
              onClick={this.navigateTOCreate}
            >
              Create
            </button>*/}
            {create_button && (
              <button
                className="custom_btn btn_pos"
                onClick={
                  simulations === false && process.env.NODE_ENV === "production"
                    ? this.contactAdmin
                    : this.navigateTOCreate
                }
              >
                Create
              </button>
            )}
          </div>
          <div>
            <h1 className="text-uppercase">My portfolios</h1>
            <div className="myPortfolio_wrap">
              <div className="myPortfolio_selection">
                <select onChange={this.handleChange}>
                  <option value="DEFAULT">LIVE AND BACKTEST</option>
                  <option value="LIVE">LIVE PORTFOLIOS</option>
                  <option value="BACKTEST">BACKTEST PORTFOLIOS</option>
                </select>
              </div>
            </div>
            {displayNoProf ? (
              <h6>
                Currently no portfolios to display, Please create new portfolio
              </h6>
            ) : null}
          </div>
        </div>
        <div className="tab-content">
          {display === "table_view" ? (
            <MyPortfolioTable
              data={selected}
              filterByName={this.filterByName}
              searchFieldInput={searchFieldInput}
              searchHandler={this.searchHandler}
              clearSearchFieldHandler={this.clearSearchFieldHandler}
            />
          ) : (
            <Fragment>
              <SearchField
                searchFieldInput={searchFieldInput}
                searchHandler={this.searchHandler}
                clearHandler={this.clearSearchFieldHandler}
              />
              <PortfolioCards
                data={NewsortedData}
                displayNoProf={displayNoProf}
                dataFetching={dataFetching}
                sortingDataError={sortedData.length > 0 ? false : true}
                noSearchResult={
                  NewsortedData.length === 0 && searchFieldInput.length > 0
                    ? true
                    : false
                }
                compare={compare}
                failedToLoadData={
                  this.state.failedToLoadCOMPARE ||
                  this.state.failedToLoadLIVE ||
                  this.state.failedToLoadBACKTEST
                }
                no_live_or_backtest_data={
                  this.state.data.length > 0 &&
                  selected.length === 0 &&
                  dataFetching === false
                    ? true
                    : false
                }
                simulations={simulations}
                create_button={create_button}
              />
            </Fragment>
          )}
        </div>
      </div>
    );
  }
}

export default connect(
  ({ user: { isAuth, userPreferences } }) => ({
    isAuth,
    userPreferences,
  }),
  (dispatch) => ({
    resetComparePortfolioData: (payload) =>
      dispatch({
        type: "RESET_COMPARE_PORTFOLIO",
      }),
    resetCreatePortfolioAnalyze: () =>
      dispatch({
        type: "RESET_CREATE_PORTFOLIO_ANALYZE",
      }),
    resetDirectReviewPortfolio: () =>
      dispatch({
        type: "RESET_DIRECT_REVIEW_PORTFOLIO_OPTIMIZE_DATA",
      }),
    resetUniverseData: () =>
      dispatch({
        type: "SET_UNIVERSE_DATA",
        payload: [],
      }),
    resetCurrentActiveStep: (value) =>
      dispatch({ type: "SET_ACTIVE_STEP_COUNT", payload: value }),
    resetSecuritiesValidToNextStep: (payload) =>
      dispatch({ type: "SET_UNIVERSE_SECURITYVALIDITY", payload }),
  })
)(Portfolios);



// WEBPACK FOOTER //
// ./src/components/pages/MyPortfolios.jsx